export interface Book {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  genre: string;
  visibility: 'Currently Featured' | 'Previously Featured' | 'Library Title';
  accessLink: string;
  accessType: 'External';
  dateAdded: string;
  readers?: number;
  clicks?: number;
  engagementRate?: number;
  authorBio?: string;
  authorCountry?: string;
}

export interface Author {
  id: string;
  name: string;
  bio: string;
  country: string;
  image: string;
  bookIds: string[];
}

export const books: Book[] = [
  {
    id: '1',
    title: 'A Voice We Find in Proximity',
    author: 'Contemporary Author',
    coverImage: '/covers/voice-proximity.png',
    description: 'A profound exploration of contemporary themes and human connection.',
    genre: 'Contemporary Fiction',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Voice-We-Find-Proximity-Contemporary/dp/0764241206',
    accessType: 'External',
    dateAdded: '2024-01-15',
  },
  {
    id: '2',
    title: 'The Cowboy Who Rode Hard',
    author: 'Western Romance Author',
    coverImage: '/covers/cowboy-rode.png',
    description: 'An opposites-attract romance set in the rugged American West.',
    genre: 'Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Cowboy-Who-Rode-Hard-Opposites-ebook/dp/B0DVMNRF67',
    accessType: 'External',
    dateAdded: '2024-01-14',
  },
  {
    id: '3',
    title: 'Knights and Knaves in Kilts Collection',
    author: 'Historical Romance Collective',
    coverImage: '/covers/knights-kilts.png',
    description: 'A captivating collection of Scottish Highland romance tales.',
    genre: 'Historical Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Knights-Knaves-Kilts-Collection-Collections-ebook/dp/B0FD8WQMQ8',
    accessType: 'External',
    dateAdded: '2024-01-13',
  },
  {
    id: '4',
    title: 'Haunted Love',
    author: 'Paranormal Romance Writer',
    coverImage: '/covers/haunted-love.png',
    description: 'A gripping standalone romance with supernatural elements.',
    genre: 'Paranormal Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Haunted-Love-Brothers-Standalone-Romance/dp/B0CVVLG8W6',
    accessType: 'External',
    dateAdded: '2024-01-12',
  },
  {
    id: '5',
    title: 'Nelson',
    author: 'European Suspense Author',
    coverImage: '/covers/nelson.png',
    description: 'An inspired romance with European suspense undertones.',
    genre: 'Romantic Suspense',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Nelson-Inspired-Romance-European-Suspense-ebook/dp/B0F73JH24X',
    accessType: 'External',
    dateAdded: '2024-01-11',
  },
  {
    id: '6',
    title: "Cowboy's Easter Surprise",
    author: 'Inspirational Author',
    coverImage: '/covers/easter-surprise.png',
    description: 'An uplifting inspirational romance set during Easter.',
    genre: 'Inspirational Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Cowboys-Easter-Surprise-Uplifting-Inspirational-ebook/dp/B0CW1M5M4K',
    accessType: 'External',
    dateAdded: '2024-01-10',
  },
  {
    id: '7',
    title: 'Amish Women of Lawrence County Trilogy',
    author: 'Amish Fiction Writer',
    coverImage: '/covers/amish-women.png',
    description: 'A heartfelt trilogy exploring Amish community and faith.',
    genre: 'Amish Fiction',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Amish-Women-Lawrence-County-Trilogy/dp/B0FBG998Y9',
    accessType: 'External',
    dateAdded: '2024-01-09',
  },
  {
    id: '8',
    title: "The Laird's Sinful Claim",
    author: 'Scottish Romance Author',
    coverImage: '/covers/laird-claim.png',
    description: 'A passionate Scottish Highland romance filled with intrigue.',
    genre: 'Historical Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/Lairds-Sinful-Claim-Scottish-Highland-ebook/dp/B0G67LVC84',
    accessType: 'External',
    dateAdded: '2024-01-08',
  },
  {
    id: '9',
    title: 'Too Clever for Courtship',
    author: 'Regency Author',
    coverImage: '/covers/clever-courtship.png',
    description: 'A witty historical romance with clever protagonists.',
    genre: 'Historical Romance',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Too-Clever-Courtship-Historical-Brothers-ebook/dp/B0F1QFY2YP',
    accessType: 'External',
    dateAdded: '2024-01-07',
  },
  {
    id: '10',
    title: 'The Last Letter',
    author: 'Rebecca Yarros',
    coverImage: '/covers/last-letter.png',
    description: 'An emotional contemporary romance about love and loss.',
    genre: 'Contemporary Romance',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Last-Letter-Rebecca-Yarros-ebook/dp/B07FCF2GYW',
    accessType: 'External',
    dateAdded: '2024-01-06',
  },
  {
    id: '11',
    title: 'Fatal Boxed Set',
    author: 'Thriller Collection',
    coverImage: '/covers/fatal-set.png',
    description: 'A gripping collection of fatal thriller stories.',
    genre: 'Thriller',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Fatal-Boxed-Set-Books-13-16-ebook/dp/B0C15VC29R',
    accessType: 'External',
    dateAdded: '2024-01-05',
  },
  {
    id: '12',
    title: 'Cendrillon',
    author: 'Robert San Souci',
    coverImage: '/covers/cendrillon.png',
    description: 'A beautifully illustrated Cinderella retelling.',
    genre: "Children's Literature",
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Cendrillon-Cinderella-Robert-San-Souci/dp/0689848889',
    accessType: 'External',
    dateAdded: '2024-01-04',
  },
  {
    id: '13',
    title: 'The Little Ghost Who Loved Quilts',
    author: 'Winter Stories Author',
    coverImage: '/covers/ghost-quilts.png',
    description: 'A charming winter tale of a friendly little ghost.',
    genre: "Children's Literature",
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Little-Ghost-Quilts-Winter-Surprise/dp/1774885379',
    accessType: 'External',
    dateAdded: '2024-01-03',
  },
  {
    id: '14',
    title: 'Everyone Belongs',
    author: 'Heather Avis',
    coverImage: '/covers/everyone-belongs.png',
    description: 'An inclusive and heartwarming story for all ages.',
    genre: "Children's Literature",
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Everyone-Belongs-Heather-Avis/dp/0593232674',
    accessType: 'External',
    dateAdded: '2024-01-02',
  },
  {
    id: '15',
    title: 'Legends of the Lure',
    author: 'Supernatural Thriller Writer',
    coverImage: '/covers/legends-lure.png',
    description: 'A supernatural thriller exploring chosen destinies.',
    genre: 'Supernatural Thriller',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Legends-Lure-Supernatural-Thriller-Chosen-ebook/dp/B0FV39HJK5',
    accessType: 'External',
    dateAdded: '2024-01-01',
  },
  {
    id: '16',
    title: 'Dracula',
    author: 'Robert Napton',
    coverImage: '/covers/dracula.png',
    description: 'A stunning graphic novel adaptation of the classic tale.',
    genre: 'Graphic Novel',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/Dracula-Robert-Napton/dp/1681160641',
    accessType: 'External',
    dateAdded: '2023-12-31',
  },
  {
    id: '17',
    title: 'Otherworld',
    author: 'Moto Hagio',
    coverImage: '/covers/otherworld.jpg',
    description: 'A captivating manga exploring parallel dimensions.',
    genre: 'Manga',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Otherworld-Barbara-Vol-Moto-Hagio/dp/1683960238',
    accessType: 'External',
    dateAdded: '2023-12-30',
  },
  {
    id: '18',
    title: 'The Beauty of Horror Coloring Book',
    author: 'Horror Artist',
    coverImage: '/covers/beauty-horror.jpg',
    description: 'A gorgeously creepy coloring book for horror enthusiasts.',
    genre: 'Art & Coloring',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Beauty-Horror-GOREgeous-Coloring-Book/dp/1631407287',
    accessType: 'External',
    dateAdded: '2023-12-29',
  },
  {
    id: '19',
    title: 'The Ghost of Christmas Spirit',
    author: 'Haunting Author',
    coverImage: '/covers/christmas-spirit.jpg',
    description: 'A haunting tale perfect for the holiday season.',
    genre: 'Paranormal',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Ghost-Christmas-Spirit-Haunting-Danielle/dp/B08998PHPX',
    accessType: 'External',
    dateAdded: '2023-12-28',
  },
  {
    id: '20',
    title: 'Something Is Killing the Children',
    author: 'James Tynion IV',
    coverImage: '/covers/killing-children.jpg',
    description: 'A terrifying horror comic about monsters and the hunters who fight them.',
    genre: 'Horror Comics',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Something-Killing-Children-James-Tynion/dp/1684158044',
    accessType: 'External',
    dateAdded: '2023-12-27',
  },
  {
    id: '21',
    title: 'The Walking Dead Book Two',
    author: 'Robert Kirkman',
    coverImage: '/covers/walking-dead.jpg',
    description: 'The continuing saga of survival in a zombie apocalypse.',
    genre: 'Horror Comics',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Walking-Dead-Book-2/dp/1582406987',
    accessType: 'External',
    dateAdded: '2023-12-26',
  },
  {
    id: '22',
    title: 'Love and Hate',
    author: 'Thriller Author',
    coverImage: '/covers/love-hate.jpg',
    description: 'A gripping thriller with shocking twists.',
    genre: 'Thriller',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Love-Hate-gripping-thriller-shocking-ebook/dp/B0DWLMHXFD',
    accessType: 'External',
    dateAdded: '2023-12-25',
  },
  {
    id: '23',
    title: 'Love and Hate Germany',
    author: 'Ryan Armstrong',
    coverImage: '/covers/love-hate-germany.jpg',
    description: 'An exploration of complex emotions set in Germany.',
    genre: 'Contemporary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Love-Hate-Germany-Ryan-Armstrong-ebook/dp/B07C847Q2S',
    accessType: 'External',
    dateAdded: '2023-12-24',
  },
  {
    id: '24',
    title: 'Mick Sinatra: Between Love and Hate',
    author: 'Romance Author',
    coverImage: '/covers/mick-sinatra.jpg',
    description: 'A passionate story of love caught between extremes.',
    genre: 'Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Mick-Sinatra-Between-Love-Hate-ebook/dp/B0GFFRL6JP',
    accessType: 'External',
    dateAdded: '2023-12-23',
  },
  {
    id: '25',
    title: 'Love and Hate College',
    author: 'College Romance Writer',
    coverImage: '/covers/love-hate-college.jpg',
    description: 'A standalone college romance exploring young love.',
    genre: 'New Adult Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Love-Hate-College-Standalone-Romance-ebook/dp/B0CLVW8XR2',
    accessType: 'External',
    dateAdded: '2023-12-22',
  },
  {
    id: '26',
    title: 'Audible Love Mom',
    author: 'Family Author',
    coverImage: '/covers/love-mom.jpg',
    description: 'A touching tribute to maternal love.',
    genre: 'Family & Relationships',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/Audible-Love-Mom/dp/B0DWNHG8L5',
    accessType: 'External',
    dateAdded: '2023-12-21',
  },
  {
    id: '27',
    title: 'I Wrote a Book About You',
    author: 'Gift Book Author',
    coverImage: '/covers/book-about-you.jpg',
    description: 'A heartfelt fill-in gift book for someone special.',
    genre: 'Gift Books',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/I-Wrote-Book-About-You/dp/1943200106',
    accessType: 'External',
    dateAdded: '2023-12-20',
  },
  {
    id: '28',
    title: 'The Midnight Garden',
    author: 'Sarah Mitchell',
    coverImage: '/covers/midnight-garden.jpg',
    description: 'A spellbinding tale of a woman who discovers a secret garden that blooms only at midnight.',
    genre: 'Literary Fiction',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE28',
    accessType: 'External',
    dateAdded: '2024-02-01',
  },
  {
    id: '29',
    title: 'Ashes of Empire',
    author: 'Jonathan Clarke',
    coverImage: '/covers/ashes-empire.jpg',
    description: 'An epic historical saga spanning three generations during the fall of the British Empire.',
    genre: 'Historical Fiction',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE29',
    accessType: 'External',
    dateAdded: '2024-02-02',
  },
  {
    id: '30',
    title: 'Beneath the Baobab',
    author: 'Thandi Nkosi',
    coverImage: '/covers/beneath-baobab.jpg',
    description: 'A coming-of-age story set in rural South Africa about a girl who defies tradition to pursue education.',
    genre: 'Literary Fiction',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE30',
    accessType: 'External',
    dateAdded: '2024-02-03',
  },
  {
    id: '31',
    title: 'Steel and Silk',
    author: 'Diana Blackwood',
    coverImage: '/covers/steel-silk.jpg',
    description: 'A gripping Victorian thriller about a female detective navigating London\'s underworld.',
    genre: 'Mystery',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE31',
    accessType: 'External',
    dateAdded: '2024-02-04',
  },
  {
    id: '32',
    title: 'The Color of Rain',
    author: 'Michael Abrams',
    coverImage: '/covers/color-rain.jpg',
    description: 'A lyrical memoir about growing up biracial in 1970s Alabama.',
    genre: 'Memoir',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE32',
    accessType: 'External',
    dateAdded: '2024-02-05',
  },
  {
    id: '33',
    title: 'Whispers in the Wheat',
    author: 'Emily Harper',
    coverImage: '/covers/whispers-wheat.jpg',
    description: 'A tender romance between two farmers fighting to save their land in rural Kansas.',
    genre: 'Romance',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE33',
    accessType: 'External',
    dateAdded: '2024-02-06',
  },
  {
    id: '34',
    title: 'The Pretoria Files',
    author: 'Sipho Dlamini',
    coverImage: '/covers/pretoria-files.jpg',
    description: 'A political thriller set in post-apartheid South Africa uncovering buried government secrets.',
    genre: 'Thriller',
    visibility: 'Currently Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE34',
    accessType: 'External',
    dateAdded: '2024-02-07',
  },
  {
    id: '35',
    title: 'Letters to My Daughter',
    author: 'Catherine Brooks',
    coverImage: '/covers/letters-daughter.jpg',
    description: 'An emotionally powerful novel told through letters from a mother during wartime Britain.',
    genre: 'Historical Fiction',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE35',
    accessType: 'External',
    dateAdded: '2024-02-08',
  },
  {
    id: '36',
    title: 'Broken Compass',
    author: 'Jake Sullivan',
    coverImage: '/covers/broken-compass.jpg',
    description: 'A survival adventure across the Alaskan wilderness after a plane crash.',
    genre: 'Adventure',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE36',
    accessType: 'External',
    dateAdded: '2024-02-09',
  },
  {
    id: '37',
    title: 'The Johannesburg Affair',
    author: 'Naledi Molefe',
    coverImage: '/covers/joburg-affair.jpg',
    description: 'A steamy romance entangled with corporate espionage in modern Johannesburg.',
    genre: 'Romantic Suspense',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE37',
    accessType: 'External',
    dateAdded: '2024-02-10',
  },
  {
    id: '38',
    title: 'The Clockmaker\'s Wife',
    author: 'Eleanor Whitfield',
    coverImage: '/covers/clockmakers-wife.jpg',
    description: 'A haunting WWII story of a clockmaker\'s wife hiding refugees in rural England.',
    genre: 'Historical Fiction',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE38',
    accessType: 'External',
    dateAdded: '2024-02-11',
  },
  {
    id: '39',
    title: 'Neon Nights',
    author: 'Tyler Jackson',
    coverImage: '/covers/neon-nights.jpg',
    description: 'A cyberpunk noir mystery set in a rain-soaked future Los Angeles.',
    genre: 'Science Fiction',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE39',
    accessType: 'External',
    dateAdded: '2024-02-12',
  },
  {
    id: '40',
    title: 'The Cape Town Diaries',
    author: 'Zandile Khumalo',
    coverImage: '/covers/capetown-diaries.jpg',
    description: 'Interconnected stories of love, loss, and hope from residents of Cape Town.',
    genre: 'Literary Fiction',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE40',
    accessType: 'External',
    dateAdded: '2024-02-13',
  },
  {
    id: '41',
    title: 'Fog Over the Thames',
    author: 'Arthur Pemberton',
    coverImage: '/covers/fog-thames.jpg',
    description: 'A detective mystery set in fog-drenched Victorian London.',
    genre: 'Mystery',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE41',
    accessType: 'External',
    dateAdded: '2024-02-14',
  },
  {
    id: '42',
    title: 'Desert Bloom',
    author: 'Amina Osman',
    coverImage: '/covers/desert-bloom.jpg',
    description: 'A poetic novel about a Somali woman building a new life in London.',
    genre: 'Contemporary Fiction',
    visibility: 'Previously Featured',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE42',
    accessType: 'External',
    dateAdded: '2024-02-15',
  },
  {
    id: '43',
    title: 'The Rebel\'s Daughter',
    author: 'Olivia Grant',
    coverImage: '/covers/rebels-daughter.jpg',
    description: 'A fierce historical romance set during the American Revolution.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE43',
    accessType: 'External',
    dateAdded: '2024-02-16',
  },
  {
    id: '44',
    title: 'Savanna Dreams',
    author: 'Bongani Ndlovu',
    coverImage: '/covers/savanna-dreams.jpg',
    description: 'A magical realism tale set on the South African savanna, where animals speak and ancestors guide.',
    genre: 'Fantasy',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE44',
    accessType: 'External',
    dateAdded: '2024-02-17',
  },
  {
    id: '45',
    title: 'Rust Belt Requiem',
    author: 'Danny Kowalski',
    coverImage: '/covers/rust-belt.jpg',
    description: 'A gritty novel about blue-collar families in America\'s declining industrial heartland.',
    genre: 'Literary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE45',
    accessType: 'External',
    dateAdded: '2024-02-18',
  },
  {
    id: '46',
    title: 'The Brighton Mysteries',
    author: 'Fiona Hartley',
    coverImage: '/covers/brighton-mysteries.jpg',
    description: 'Cozy mysteries set in the charming seaside town of Brighton, England.',
    genre: 'Mystery',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE46',
    accessType: 'External',
    dateAdded: '2024-02-19',
  },
  {
    id: '47',
    title: 'Between Two Worlds',
    author: 'Lerato Mthembu',
    coverImage: '/covers/two-worlds.jpg',
    description: 'A young woman navigates between traditional Zulu culture and modern city life in Durban.',
    genre: 'Contemporary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE47',
    accessType: 'External',
    dateAdded: '2024-02-20',
  },
  {
    id: '48',
    title: 'The Pilot\'s Promise',
    author: 'Richard Hayes',
    coverImage: '/covers/pilots-promise.jpg',
    description: 'A WWII romance about a fighter pilot and the nurse who waits for him.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE48',
    accessType: 'External',
    dateAdded: '2024-02-21',
  },
  {
    id: '49',
    title: 'Starfall',
    author: 'Megan Torres',
    coverImage: '/covers/starfall.jpg',
    description: 'A young adult space opera about a teenage girl commanding a starship.',
    genre: 'Science Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE49',
    accessType: 'External',
    dateAdded: '2024-02-22',
  },
  {
    id: '50',
    title: 'The Vineyard\'s Secret',
    author: 'Charlotte Evans',
    coverImage: '/covers/vineyard-secret.jpg',
    description: 'A woman inherits a vineyard in Napa Valley and uncovers a family secret spanning decades.',
    genre: 'Contemporary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE50',
    accessType: 'External',
    dateAdded: '2024-02-23',
  },
  {
    id: '51',
    title: 'Blood on the Highveld',
    author: 'Mandla Sithole',
    coverImage: '/covers/blood-highveld.jpg',
    description: 'A crime thriller following a detective through South Africa\'s most dangerous cases.',
    genre: 'Thriller',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE51',
    accessType: 'External',
    dateAdded: '2024-02-24',
  },
  {
    id: '52',
    title: 'The Lighthouse Keeper',
    author: 'Margaret Walsh',
    coverImage: '/covers/lighthouse-keeper.jpg',
    description: 'A reclusive lighthouse keeper in Cornwall finds connection through letters washed ashore.',
    genre: 'Literary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE52',
    accessType: 'External',
    dateAdded: '2024-02-25',
  },
  {
    id: '53',
    title: 'Southern Charm',
    author: 'Bella Johnson',
    coverImage: '/covers/southern-charm.jpg',
    description: 'A sweet Southern romance set among the magnolias of Charleston.',
    genre: 'Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE53',
    accessType: 'External',
    dateAdded: '2024-02-26',
  },
  {
    id: '54',
    title: 'The Last Safari',
    author: 'Pieter van der Berg',
    coverImage: '/covers/last-safari.jpg',
    description: 'A conservation thriller about rangers fighting poachers in Kruger National Park.',
    genre: 'Adventure',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE54',
    accessType: 'External',
    dateAdded: '2024-02-27',
  },
  {
    id: '55',
    title: 'Echoes of Manchester',
    author: 'David Thornton',
    coverImage: '/covers/echoes-manchester.jpg',
    description: 'Working-class stories from post-industrial Manchester, raw and unforgettable.',
    genre: 'Literary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE55',
    accessType: 'External',
    dateAdded: '2024-02-28',
  },
  {
    id: '56',
    title: 'The Oracle of Soweto',
    author: 'Nomsa Dube',
    coverImage: '/covers/oracle-soweto.jpg',
    description: 'A young sangoma in Soweto must use her gift to solve a community mystery.',
    genre: 'Fantasy',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE56',
    accessType: 'External',
    dateAdded: '2024-03-01',
  },
  {
    id: '57',
    title: 'Manhattan After Dark',
    author: 'Chris Rodriguez',
    coverImage: '/covers/manhattan-dark.jpg',
    description: 'A noir thriller set in the jazz clubs and back alleys of 1940s New York.',
    genre: 'Thriller',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE57',
    accessType: 'External',
    dateAdded: '2024-03-02',
  },
  {
    id: '58',
    title: 'The Beekeeper\'s Apprentice',
    author: 'Hannah Morris',
    coverImage: '/covers/beekeeper.jpg',
    description: 'A heartwarming story of an elderly beekeeper mentoring a troubled teenager in the Cotswolds.',
    genre: 'Contemporary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE58',
    accessType: 'External',
    dateAdded: '2024-03-03',
  },
  {
    id: '59',
    title: 'Kalahari Sunrise',
    author: 'Lindiwe Botha',
    coverImage: '/covers/kalahari-sunrise.jpg',
    description: 'A love story blooming between a geologist and a conservationist in the Kalahari Desert.',
    genre: 'Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE59',
    accessType: 'External',
    dateAdded: '2024-03-04',
  },
  {
    id: '60',
    title: 'The Edinburgh Inheritance',
    author: 'Alistair Campbell',
    coverImage: '/covers/edinburgh-inheritance.jpg',
    description: 'A family saga spanning centuries in Scotland\'s capital, full of secrets and ambition.',
    genre: 'Historical Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE60',
    accessType: 'External',
    dateAdded: '2024-03-05',
  },
  {
    id: '61',
    title: 'Wildfire Season',
    author: 'Rachel Cooper',
    coverImage: '/covers/wildfire-season.jpg',
    description: 'A firefighter romance set during California\'s devastating wildfire season.',
    genre: 'Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE61',
    accessType: 'External',
    dateAdded: '2024-03-06',
  },
  {
    id: '62',
    title: 'Table Mountain',
    author: 'Andre Visser',
    coverImage: '/covers/table-mountain.jpg',
    description: 'A literary novel about three strangers whose lives intersect on Cape Town\'s iconic peak.',
    genre: 'Literary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE62',
    accessType: 'External',
    dateAdded: '2024-03-07',
  },
  {
    id: '63',
    title: 'The Widow\'s Walk',
    author: 'Patricia Donovan',
    coverImage: '/covers/widows-walk.jpg',
    description: 'A gothic mystery set in a crumbling New England mansion.',
    genre: 'Mystery',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE63',
    accessType: 'External',
    dateAdded: '2024-03-08',
  },
  {
    id: '64',
    title: 'Gold Rush Hearts',
    author: 'Stephanie Blake',
    coverImage: '/covers/gold-rush.jpg',
    description: 'A historical romance set during the California Gold Rush.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE64',
    accessType: 'External',
    dateAdded: '2024-03-09',
  },
  {
    id: '65',
    title: 'The Durban Express',
    author: 'Jabu Mkhize',
    coverImage: '/covers/durban-express.jpg',
    description: 'A fast-paced thriller aboard a luxury train from Johannesburg to Durban.',
    genre: 'Thriller',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE65',
    accessType: 'External',
    dateAdded: '2024-03-10',
  },
  {
    id: '66',
    title: 'Pemberley Revisited',
    author: 'Caroline Ashworth',
    coverImage: '/covers/pemberley.jpg',
    description: 'A loving sequel to Pride and Prejudice, following Elizabeth and Darcy\'s married life.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE66',
    accessType: 'External',
    dateAdded: '2024-03-11',
  },
  {
    id: '67',
    title: 'The Harlem Renaissance',
    author: 'Marcus Davis',
    coverImage: '/covers/harlem-renaissance.jpg',
    description: 'A vivid novel capturing the art, music, and passion of 1920s Harlem.',
    genre: 'Historical Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE67',
    accessType: 'External',
    dateAdded: '2024-03-12',
  },
  {
    id: '68',
    title: 'Frost & Flame',
    author: 'Lucy Archer',
    coverImage: '/covers/frost-flame.jpg',
    description: 'An enemies-to-lovers fantasy romance with elemental magic.',
    genre: 'Fantasy',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE68',
    accessType: 'External',
    dateAdded: '2024-03-13',
  },
  {
    id: '69',
    title: 'Robben Island Letters',
    author: 'Themba Cele',
    coverImage: '/covers/robben-island.jpg',
    description: 'A powerful epistolary novel based on letters smuggled from Robben Island.',
    genre: 'Historical Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE69',
    accessType: 'External',
    dateAdded: '2024-03-14',
  },
  {
    id: '70',
    title: 'The Baker Street Legacy',
    author: 'Simon Crawford',
    coverImage: '/covers/baker-street.jpg',
    description: 'A modern Sherlock Holmes-inspired mystery set in contemporary London.',
    genre: 'Mystery',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE70',
    accessType: 'External',
    dateAdded: '2024-03-15',
  },
  {
    id: '71',
    title: 'Prairie Fire',
    author: 'Laura Bennett',
    coverImage: '/covers/prairie-fire.jpg',
    description: 'A frontier romance about a schoolteacher and a rancher in 1880s Montana.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE71',
    accessType: 'External',
    dateAdded: '2024-03-16',
  },
  {
    id: '72',
    title: 'Soweto Stories',
    author: 'Palesa Tshabalala',
    coverImage: '/covers/soweto-stories.jpg',
    description: 'A short story collection celebrating everyday heroes in Soweto.',
    genre: 'Literary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE72',
    accessType: 'External',
    dateAdded: '2024-03-17',
  },
  {
    id: '73',
    title: 'The Oxford Don',
    author: 'Geoffrey Palmer',
    coverImage: '/covers/oxford-don.jpg',
    description: 'An academic mystery set among the spires and secrets of Oxford University.',
    genre: 'Mystery',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE73',
    accessType: 'External',
    dateAdded: '2024-03-18',
  },
  {
    id: '74',
    title: 'American Dreamers',
    author: 'Sofia Rivera',
    coverImage: '/covers/american-dreamers.jpg',
    description: 'A multigenerational immigrant story set in Los Angeles.',
    genre: 'Contemporary Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE74',
    accessType: 'External',
    dateAdded: '2024-03-19',
  },
  {
    id: '75',
    title: 'The Garden Route',
    author: 'Elise du Plessis',
    coverImage: '/covers/garden-route.jpg',
    description: 'A road-trip romance along South Africa\'s breathtaking Garden Route.',
    genre: 'Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE75',
    accessType: 'External',
    dateAdded: '2024-03-20',
  },
  {
    id: '76',
    title: 'Midnight in Mayfair',
    author: 'Victoria Sinclair',
    coverImage: '/covers/midnight-mayfair.jpg',
    description: 'A glamorous Regency romance set among London\'s elite.',
    genre: 'Historical Romance',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE76',
    accessType: 'External',
    dateAdded: '2024-03-21',
  },
  {
    id: '77',
    title: 'The Freedom Riders',
    author: 'James Washington',
    coverImage: '/covers/freedom-riders.jpg',
    description: 'A historical novel about the Civil Rights movement in 1960s Mississippi.',
    genre: 'Historical Fiction',
    visibility: 'Library Title',
    accessLink: 'https://www.amazon.com/dp/B0EXAMPLE77',
    accessType: 'External',
    dateAdded: '2024-03-22',
  },
];

export const authors: Author[] = [
  { id: '1', name: 'Rebecca Yarros', bio: 'Rebecca Yarros is a New York Times bestselling author known for her emotionally charged contemporary romance novels.', country: 'United States', image: '/authors/rebecca-yarros.jpg', bookIds: ['10'] },
  { id: '2', name: 'Robert San Souci', bio: 'Robert D. San Souci is an award-winning author celebrated for his retellings of folk tales and fairy tales.', country: 'United States', image: '/authors/robert-san-souci.jpg', bookIds: ['12'] },
  { id: '3', name: 'Heather Avis', bio: 'Heather Avis is an author and advocate for inclusion and belonging, writing stories that celebrate diversity.', country: 'United States', image: '/authors/heather-avis.jpg', bookIds: ['14'] },
  { id: '4', name: 'James Tynion IV', bio: 'James Tynion IV is an Eisner Award-winning comic book writer known for his work in horror and superhero genres.', country: 'United States', image: '/authors/james-tynion.jpg', bookIds: ['20'] },
  { id: '5', name: 'Robert Kirkman', bio: 'Robert Kirkman is the creator of The Walking Dead and Invincible, revolutionizing modern comics.', country: 'United States', image: '/authors/robert-kirkman.jpg', bookIds: ['21'] },
  { id: '6', name: 'Moto Hagio', bio: 'Moto Hagio is a legendary manga artist and one of the founding members of the Year 24 Group.', country: 'Japan', image: '/authors/moto-hagio.jpg', bookIds: ['17'] },
  { id: '7', name: 'Sarah Mitchell', bio: 'Sarah Mitchell writes enchanting literary fiction exploring hidden worlds and feminine resilience.', country: 'United States', image: '', bookIds: ['28'] },
  { id: '8', name: 'Jonathan Clarke', bio: 'Jonathan Clarke is a British historian and novelist known for sweeping sagas of empire and legacy.', country: 'United Kingdom', image: '', bookIds: ['29'] },
  { id: '9', name: 'Thandi Nkosi', bio: 'Thandi Nkosi is a South African author whose debut novel won the Barry Ronge Fiction Prize.', country: 'South Africa', image: '', bookIds: ['30'] },
  { id: '10', name: 'Diana Blackwood', bio: 'Diana Blackwood writes Victorian-era mysteries featuring fierce female protagonists.', country: 'United Kingdom', image: '', bookIds: ['31'] },
  { id: '11', name: 'Michael Abrams', bio: 'Michael Abrams is an American memoirist and essayist exploring race, identity, and belonging.', country: 'United States', image: '', bookIds: ['32'] },
  { id: '12', name: 'Emily Harper', bio: 'Emily Harper writes heartfelt rural romances rooted in the American Midwest.', country: 'United States', image: '', bookIds: ['33'] },
  { id: '13', name: 'Sipho Dlamini', bio: 'Sipho Dlamini is a South African journalist and thriller writer exposing corruption and injustice.', country: 'South Africa', image: '', bookIds: ['34'] },
  { id: '14', name: 'Catherine Brooks', bio: 'Catherine Brooks writes emotionally rich historical fiction set during the World Wars.', country: 'United Kingdom', image: '', bookIds: ['35'] },
  { id: '15', name: 'Jake Sullivan', bio: 'Jake Sullivan writes edge-of-your-seat survival adventure novels set in extreme environments.', country: 'United States', image: '', bookIds: ['36'] },
  { id: '16', name: 'Naledi Molefe', bio: 'Naledi Molefe writes romantic suspense novels set in modern South Africa.', country: 'South Africa', image: '', bookIds: ['37'] },
  { id: '17', name: 'Eleanor Whitfield', bio: 'Eleanor Whitfield is a British author of wartime fiction praised for her meticulous research.', country: 'United Kingdom', image: '', bookIds: ['38'] },
  { id: '18', name: 'Tyler Jackson', bio: 'Tyler Jackson writes cyberpunk and noir fiction blending technology with classic detective storytelling.', country: 'United States', image: '', bookIds: ['39'] },
  { id: '19', name: 'Zandile Khumalo', bio: 'Zandile Khumalo is a South African short story writer and winner of the Nadine Gordimer Prize.', country: 'South Africa', image: '', bookIds: ['40'] },
  { id: '20', name: 'Arthur Pemberton', bio: 'Arthur Pemberton writes atmospheric Victorian mysteries in the tradition of Arthur Conan Doyle.', country: 'United Kingdom', image: '', bookIds: ['41'] },
  { id: '21', name: 'Amina Osman', bio: 'Amina Osman writes lyrical contemporary fiction about the Somali diaspora experience.', country: 'United Kingdom', image: '', bookIds: ['42'] },
  { id: '22', name: 'Olivia Grant', bio: 'Olivia Grant writes fiery historical romances set during pivotal moments in American history.', country: 'United States', image: '', bookIds: ['43'] },
  { id: '23', name: 'Bongani Ndlovu', bio: 'Bongani Ndlovu is a South African fantasy author weaving indigenous folklore into magical worlds.', country: 'South Africa', image: '', bookIds: ['44'] },
  { id: '24', name: 'Danny Kowalski', bio: 'Danny Kowalski writes gritty literary fiction about working-class America.', country: 'United States', image: '', bookIds: ['45'] },
  { id: '25', name: 'Fiona Hartley', bio: 'Fiona Hartley writes charming cozy mysteries set in British seaside towns.', country: 'United Kingdom', image: '', bookIds: ['46'] },
  { id: '26', name: 'Lerato Mthembu', bio: 'Lerato Mthembu explores the tension between tradition and modernity in contemporary South African fiction.', country: 'South Africa', image: '', bookIds: ['47'] },
  { id: '27', name: 'Richard Hayes', bio: 'Richard Hayes writes deeply researched WWII romances honoring the sacrifices of the Greatest Generation.', country: 'United States', image: '', bookIds: ['48'] },
  { id: '28', name: 'Megan Torres', bio: 'Megan Torres writes thrilling young adult science fiction with strong female leads.', country: 'United States', image: '', bookIds: ['49'] },
  { id: '29', name: 'Charlotte Evans', bio: 'Charlotte Evans writes contemporary fiction about family secrets and second chances.', country: 'United States', image: '', bookIds: ['50'] },
  { id: '30', name: 'Mandla Sithole', bio: 'Mandla Sithole is a South African crime fiction writer and former police detective.', country: 'South Africa', image: '', bookIds: ['51'] },
  { id: '31', name: 'Margaret Walsh', bio: 'Margaret Walsh writes beautiful literary fiction set along the dramatic Cornish coast.', country: 'United Kingdom', image: '', bookIds: ['52'] },
  { id: '32', name: 'Bella Johnson', bio: 'Bella Johnson writes sweet Southern romance novels full of charm and warmth.', country: 'United States', image: '', bookIds: ['53'] },
  { id: '33', name: 'Pieter van der Berg', bio: 'Pieter van der Berg writes conservation-themed adventure novels set in Southern Africa.', country: 'South Africa', image: '', bookIds: ['54'] },
  { id: '34', name: 'David Thornton', bio: 'David Thornton writes raw, working-class literary fiction from Northern England.', country: 'United Kingdom', image: '', bookIds: ['55'] },
  { id: '35', name: 'Nomsa Dube', bio: 'Nomsa Dube writes fantasy fiction drawing on South African traditional beliefs and urban culture.', country: 'South Africa', image: '', bookIds: ['56'] },
  { id: '36', name: 'Chris Rodriguez', bio: 'Chris Rodriguez writes noir thrillers set in mid-century American cities.', country: 'United States', image: '', bookIds: ['57'] },
  { id: '37', name: 'Hannah Morris', bio: 'Hannah Morris writes heartwarming contemporary fiction set in the English countryside.', country: 'United Kingdom', image: '', bookIds: ['58'] },
  { id: '38', name: 'Lindiwe Botha', bio: 'Lindiwe Botha writes romance novels set against South Africa\'s stunning natural landscapes.', country: 'South Africa', image: '', bookIds: ['59'] },
  { id: '39', name: 'Alistair Campbell', bio: 'Alistair Campbell writes sweeping Scottish family sagas spanning centuries.', country: 'United Kingdom', image: '', bookIds: ['60'] },
  { id: '40', name: 'Rachel Cooper', bio: 'Rachel Cooper writes contemporary romance featuring first responders and everyday heroes.', country: 'United States', image: '', bookIds: ['61'] },
  { id: '41', name: 'Andre Visser', bio: 'Andre Visser writes literary fiction exploring South African identity and landscape.', country: 'South Africa', image: '', bookIds: ['62'] },
  { id: '42', name: 'Patricia Donovan', bio: 'Patricia Donovan writes gothic mysteries set in atmospheric New England settings.', country: 'United States', image: '', bookIds: ['63'] },
  { id: '43', name: 'Stephanie Blake', bio: 'Stephanie Blake writes vivid historical romances set during America\'s most dramatic eras.', country: 'United States', image: '', bookIds: ['64'] },
  { id: '44', name: 'Jabu Mkhize', bio: 'Jabu Mkhize writes fast-paced South African thrillers with sharp social commentary.', country: 'South Africa', image: '', bookIds: ['65'] },
  { id: '45', name: 'Caroline Ashworth', bio: 'Caroline Ashworth writes beloved Austen-inspired Regency romances.', country: 'United Kingdom', image: '', bookIds: ['66'] },
  { id: '46', name: 'Marcus Davis', bio: 'Marcus Davis writes vivid historical fiction celebrating African American culture and resilience.', country: 'United States', image: '', bookIds: ['67'] },
  { id: '47', name: 'Lucy Archer', bio: 'Lucy Archer writes fantasy romance with elemental magic systems and slow-burn love stories.', country: 'United Kingdom', image: '', bookIds: ['68'] },
  { id: '48', name: 'Themba Cele', bio: 'Themba Cele writes powerful historical fiction about South Africa\'s struggle for freedom.', country: 'South Africa', image: '', bookIds: ['69'] },
  { id: '49', name: 'Simon Crawford', bio: 'Simon Crawford writes modern detective fiction inspired by the great British mystery tradition.', country: 'United Kingdom', image: '', bookIds: ['70'] },
  { id: '50', name: 'Laura Bennett', bio: 'Laura Bennett writes frontier romances capturing the spirit of the American West.', country: 'United States', image: '', bookIds: ['71'] },
  { id: '51', name: 'Palesa Tshabalala', bio: 'Palesa Tshabalala writes short fiction celebrating the spirit and resilience of Soweto.', country: 'South Africa', image: '', bookIds: ['72'] },
  { id: '52', name: 'Geoffrey Palmer', bio: 'Geoffrey Palmer writes academic mysteries set in Britain\'s most prestigious universities.', country: 'United Kingdom', image: '', bookIds: ['73'] },
  { id: '53', name: 'Sofia Rivera', bio: 'Sofia Rivera writes multigenerational immigrant stories set in modern America.', country: 'United States', image: '', bookIds: ['74'] },
  { id: '54', name: 'Elise du Plessis', bio: 'Elise du Plessis writes romance novels set against South Africa\'s most beautiful landscapes.', country: 'South Africa', image: '', bookIds: ['75'] },
  { id: '55', name: 'Victoria Sinclair', bio: 'Victoria Sinclair writes glamorous Regency romances set among London\'s high society.', country: 'United Kingdom', image: '', bookIds: ['76'] },
  { id: '56', name: 'James Washington', bio: 'James Washington writes important historical fiction about the American Civil Rights movement.', country: 'United States', image: '', bookIds: ['77'] },
  { id: '57', name: 'Aiko Tanaka', bio: 'Aiko Tanaka writes lyrical literary fiction exploring family, memory, and the changing seasons of Kyoto.', country: 'Japan', image: '', bookIds: [] },
  { id: '58', name: 'Henrik Lindqvist', bio: 'Henrik Lindqvist is a Swedish crime novelist known for atmospheric Nordic noir thrillers.', country: 'Sweden', image: '', bookIds: [] },
  { id: '59', name: 'Isabela Moreno', bio: 'Isabela Moreno crafts magical realism rooted in the rainforests and folklore of Brazil.', country: 'Brazil', image: '', bookIds: [] },
  { id: '60', name: 'Adaeze Okonkwo', bio: 'Adaeze Okonkwo writes contemporary Nigerian fiction about ambition, faith, and family.', country: 'Nigeria', image: '', bookIds: [] },
  { id: '61', name: 'Liam O\'Sullivan', bio: 'Liam O\'Sullivan writes haunting literary fiction set along the windswept coasts of western Ireland.', country: 'Ireland', image: '', bookIds: [] },
  { id: '62', name: 'Priya Sharma', bio: 'Priya Sharma writes sweeping historical sagas set across modern and colonial India.', country: 'India', image: '', bookIds: [] },
  { id: '63', name: 'Mateo Alvarez', bio: 'Mateo Alvarez writes literary thrillers exploring memory, exile, and identity in Buenos Aires.', country: 'Argentina', image: '', bookIds: [] },
  { id: '64', name: 'Chloe Beaumont', bio: 'Chloe Beaumont writes elegant literary fiction set among the vineyards and villages of Provence.', country: 'France', image: '', bookIds: [] },
  { id: '65', name: 'Daniel Cohen', bio: 'Daniel Cohen writes literary fiction examining displacement and belonging in modern Tel Aviv.', country: 'Israel', image: '', bookIds: [] },
  { id: '66', name: 'Yusuf Demir', bio: 'Yusuf Demir is a Turkish novelist celebrated for richly historical tales of Istanbul.', country: 'Turkey', image: '', bookIds: [] },
  { id: '67', name: 'Sienna Walker', bio: 'Sienna Walker writes outback fiction capturing the rhythms and stories of rural Australia.', country: 'Australia', image: '', bookIds: [] },
  { id: '68', name: 'Marcus Chen', bio: 'Marcus Chen writes near-future science fiction exploring AI, ethics, and humanity.', country: 'Singapore', image: '', bookIds: [] },
  { id: '69', name: 'Olufemi Adeyemi', bio: 'Olufemi Adeyemi writes Afrofuturist novels weaving Yoruba mythology with speculative storytelling.', country: 'Nigeria', image: '', bookIds: [] },
  { id: '70', name: 'Fatima Hassan', bio: 'Fatima Hassan writes contemporary fiction about womanhood, faith, and modernity in Cairo.', country: 'Egypt', image: '', bookIds: [] },
  { id: '71', name: 'Hugo Müller', bio: 'Hugo Müller writes philosophical literary fiction set in postwar Berlin.', country: 'Germany', image: '', bookIds: [] },
  { id: '72', name: 'Anya Volkov', bio: 'Anya Volkov writes epic historical fiction set during the Russian revolutions and beyond.', country: 'Russia', image: '', bookIds: [] },
  { id: '73', name: 'Elena Rossi', bio: 'Elena Rossi writes lush historical romances set in Renaissance and modern Italy.', country: 'Italy', image: '', bookIds: [] },
  { id: '74', name: 'Soo-jin Park', bio: 'Soo-jin Park writes literary fiction exploring family secrets across generations of Seoul.', country: 'South Korea', image: '', bookIds: [] },
  { id: '75', name: 'Maya Ahmadi', bio: 'Maya Ahmadi is an Iranian-Canadian writer whose novels examine diaspora and intergenerational love.', country: 'Canada', image: '', bookIds: [] },
  { id: '76', name: 'Jose Rivera', bio: 'Jose Rivera writes vivid coming-of-age stories set in the colonias of Mexico City.', country: 'Mexico', image: '', bookIds: [] },
  { id: '77', name: 'Tariq Mahmood', bio: 'Tariq Mahmood writes literary thrillers set across Karachi and the Pakistani frontier.', country: 'Pakistan', image: '', bookIds: [] },
  { id: '78', name: 'Sophie Laurent', bio: 'Sophie Laurent writes intimate literary fiction about Parisian artists and quiet revolutions.', country: 'France', image: '', bookIds: [] },
  { id: '79', name: 'Nathan Brooks', bio: 'Nathan Brooks writes wilderness adventure novels inspired by the Canadian Rockies.', country: 'Canada', image: '', bookIds: [] },
  { id: '80', name: 'Amara Diallo', bio: 'Amara Diallo writes powerful contemporary fiction examining tradition and change in Dakar.', country: 'Senegal', image: '', bookIds: [] },
  { id: '81', name: 'Ingrid Hansen', bio: 'Ingrid Hansen writes literary mysteries set against Norway\'s fjords and small coastal towns.', country: 'Norway', image: '', bookIds: [] },
  { id: '82', name: 'Camila Vargas', bio: 'Camila Vargas writes magical realism inspired by the markets and mountains of Bogotá.', country: 'Colombia', image: '', bookIds: [] },
  { id: '83', name: 'Joost van Dijk', bio: 'Joost van Dijk writes urbane literary fiction about modern Amsterdam life.', country: 'Netherlands', image: '', bookIds: [] },
  { id: '84', name: 'Wei Zhang', bio: 'Wei Zhang writes sweeping historical fiction tracing Chinese family dynasties through revolution and reform.', country: 'China', image: '', bookIds: [] },
  { id: '85', name: 'Paloma Reyes', bio: 'Paloma Reyes writes literary romance set in the streets and cafés of Madrid.', country: 'Spain', image: '', bookIds: [] },
  { id: '86', name: 'Kofi Boateng', bio: 'Kofi Boateng writes contemporary fiction exploring Accra\'s vibrant youth culture and political change.', country: 'Ghana', image: '', bookIds: [] },
  { id: '87', name: 'Ruth Levine', bio: 'Ruth Levine writes warmhearted family sagas set across Brooklyn\'s immigrant generations.', country: 'United States', image: '', bookIds: [] },
  { id: '88', name: 'Khaled Mansour', bio: 'Khaled Mansour writes lyrical literary fiction examining war, exile, and memory in modern Beirut.', country: 'Lebanon', image: '', bookIds: [] },
  { id: '89', name: 'Zara Ahmed', bio: 'Zara Ahmed writes feminist literary fiction about South Asian women in modern London.', country: 'United Kingdom', image: '', bookIds: [] },
  { id: '90', name: 'Hiroshi Sato', bio: 'Hiroshi Sato writes intricate detective fiction set in the back alleys of Tokyo.', country: 'Japan', image: '', bookIds: [] },
  { id: '91', name: 'Astrid Eriksen', bio: 'Astrid Eriksen writes Nordic fantasy drawing on Sami folklore and Arctic landscapes.', country: 'Norway', image: '', bookIds: [] },
  { id: '92', name: 'Gabriel Santos', bio: 'Gabriel Santos writes literary thrillers set in the favelas and beaches of Rio de Janeiro.', country: 'Brazil', image: '', bookIds: [] },
  { id: '93', name: 'Nour Khalil', bio: 'Nour Khalil writes intimate contemporary fiction about Jordanian women navigating family and ambition.', country: 'Jordan', image: '', bookIds: [] },
  { id: '94', name: 'Ben Carter', bio: 'Ben Carter writes literary fiction capturing the surf and small-town life of New Zealand\'s North Island.', country: 'New Zealand', image: '', bookIds: [] },
  { id: '95', name: 'Marta Kowalczyk', bio: 'Marta Kowalczyk writes historical fiction set in Poland during and after the Second World War.', country: 'Poland', image: '', bookIds: [] },
  { id: '96', name: 'Devika Rao', bio: 'Devika Rao writes contemporary romance set among the bustling cafés of Bangalore.', country: 'India', image: '', bookIds: [] },
  { id: '97', name: 'Anders Holm', bio: 'Anders Holm writes literary crime fiction set across Denmark\'s quiet seaside towns.', country: 'Denmark', image: '', bookIds: [] },
  { id: '98', name: 'Mei Lin', bio: 'Mei Lin writes speculative fiction blending Taiwanese folklore with cyberpunk futures.', country: 'Taiwan', image: '', bookIds: [] },
  { id: '99', name: 'Tomás Herrera', bio: 'Tomás Herrera writes lyrical fiction inspired by the deserts and coastlines of northern Chile.', country: 'Chile', image: '', bookIds: [] },
  { id: '100', name: 'Grace Mwangi', bio: 'Grace Mwangi writes contemporary fiction set in Nairobi, exploring tech, tradition, and youth.', country: 'Kenya', image: '', bookIds: [] },
  { id: '101', name: 'Oliver Hartwell', bio: 'Oliver Hartwell writes literary spy fiction in the tradition of le Carré.', country: 'United Kingdom', image: '', bookIds: [] },
  { id: '102', name: 'Layla Karimi', bio: 'Layla Karimi writes lyrical historical fiction inspired by Persian poetry and the gardens of Shiraz.', country: 'Iran', image: '', bookIds: [] },
  { id: '103', name: 'Ezra Goldberg', bio: 'Ezra Goldberg writes literary memoirs about faith, doubt, and family across three continents.', country: 'United States', image: '', bookIds: [] },
  { id: '104', name: 'Chiamaka Eze', bio: 'Chiamaka Eze writes coming-of-age novels about young women in contemporary Lagos.', country: 'Nigeria', image: '', bookIds: [] },
  { id: '105', name: 'Lucas Schmidt', bio: 'Lucas Schmidt writes literary thrillers set in the financial corridors of Frankfurt.', country: 'Germany', image: '', bookIds: [] },
  { id: '106', name: 'Naomi Tanaka', bio: 'Naomi Tanaka writes contemplative short fiction about urban loneliness and small kindnesses.', country: 'Japan', image: '', bookIds: [] },
  { id: '107', name: 'Sebastián Cruz', bio: 'Sebastián Cruz writes vivid historical fiction tracing the conquistadors and the indigenous peoples of Peru.', country: 'Peru', image: '', bookIds: [] },
  { id: '108', name: 'Aroha Tane', bio: 'Aroha Tane is a Māori novelist writing literary fiction grounded in whakapapa and the land.', country: 'New Zealand', image: '', bookIds: [] },
  { id: '109', name: 'Dimitri Petrov', bio: 'Dimitri Petrov writes philosophical fiction set among the cafes and ruins of Athens.', country: 'Greece', image: '', bookIds: [] },
  { id: '110', name: 'Hannah Kim', bio: 'Hannah Kim writes literary YA fiction about Korean American teens navigating identity.', country: 'United States', image: '', bookIds: [] },
  { id: '111', name: 'Aleksander Nowak', bio: 'Aleksander Nowak writes literary fiction examining Poland\'s post-Soviet transformation.', country: 'Poland', image: '', bookIds: [] },
  { id: '112', name: 'Yara Saleh', bio: 'Yara Saleh writes contemporary fiction about Palestinian women and the meaning of home.', country: 'Palestine', image: '', bookIds: [] },
  { id: '113', name: 'Felipe Ramos', bio: 'Felipe Ramos writes literary noir set in the night markets of Mexico City.', country: 'Mexico', image: '', bookIds: [] },
  { id: '114', name: 'Saoirse Doyle', bio: 'Saoirse Doyle writes folkloric fantasy rooted in Irish myth and the wild Atlantic coast.', country: 'Ireland', image: '', bookIds: [] },
  { id: '115', name: 'Tobias Berg', bio: 'Tobias Berg writes literary mysteries set across the Stockholm archipelago.', country: 'Sweden', image: '', bookIds: [] },
  { id: '116', name: 'Lila Nguyen', bio: 'Lila Nguyen writes literary fiction about Vietnamese diaspora families across Saigon and California.', country: 'Vietnam', image: '', bookIds: [] },
];

export const genres = [
  'Contemporary Fiction',
  'Romance',
  'Historical Romance',
  'Paranormal Romance',
  'Thriller',
  "Children's Literature",
  'Graphic Novel',
  'Manga',
  'Horror Comics',
  'Inspirational Romance',
  'Amish Fiction',
  'Literary Fiction',
  'Historical Fiction',
  'Mystery',
  'Memoir',
  'Science Fiction',
  'Fantasy',
  'Adventure',
  'Romantic Suspense',
  'New Adult Romance',
];

export const getBooksByVisibility = (visibility: Book['visibility']) => 
  books.filter(book => book.visibility === visibility);

export const getBooksByGenre = (genre: string) =>
  books.filter(book => book.genre === genre);

export const getBookById = (id: string) =>
  books.find(book => book.id === id);

export const getAuthorById = (id: string) =>
  authors.find(author => author.id === id);

export const getAuthorBooks = (authorId: string) => {
  const author = getAuthorById(authorId);
  if (!author) return [];
  return books.filter(book => author.bookIds.includes(book.id));
};
